const PSEvents = require('PSEvents');
const SlotUI = require('SlotUI');

cc.Class({
    extends: cc.Component,

    properties: {
        target: cc.Node,
    },

    onLoad () {
        if (!this.target) {
            this.target = this.node;
        }
        this.target.active = false;
        PSEvents.onEngineInitialized(() => {
            const { clickHandler, enabled } = SlotUI.getMenuElement(SlotUI.MenuElements.Deposit);

            if (enabled && clickHandler) {
                this.target.active = true;
                this.clickHandler = clickHandler;
            }
        });
    },

    click () {
        this.clickHandler();
    }
});
